import React from 'react'
import { Button, Input, Label } from '@/shared/ui'

export default function RewardsBingxUidForm({
  disabled,
  onSubmit,
}: {
  disabled?: boolean
  onSubmit: (uid: string) => Promise<void>
}) {
  const [uid, setUid] = React.useState('')
  const [saving, setSaving] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    const v = uid.trim()
    if (!v) {
      setError('Informe o UID da sua conta na BingX.')
      return
    }
    setSaving(true)
    try {
      await onSubmit(v)
      setUid('')
    } catch (e: any) {
      setError(e?.message || 'Falha ao vincular UID')
    } finally {
      setSaving(false)
    }
  }

  return (
    <form className="space-y-3" onSubmit={submit}>
      {error && <div className="rounded-md border border-red-500/30 bg-red-500/10 p-2 text-sm text-foreground">{error}</div>}

      <div className="space-y-1.5">
        <Label>Seu UID na BingX</Label>
        <Input value={uid} onChange={(e) => setUid((e.target as HTMLInputElement).value)} placeholder="Ex.: 24828902" disabled={saving || disabled} />
        <div className="text-xs text-foreground/60">
          Dica: no app/site da BingX, procure por &quot;UID&quot; no perfil/central da conta e copie o número.
        </div>
      </div>

      <div className="flex justify-end">
        <Button type="submit" disabled={saving || disabled}>
          {saving ? 'Vinculando...' : 'Vincular UID'}
        </Button>
      </div>
    </form>
  )
}

